module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"confirmation-title":"Adicionar membro da família","confirmation-message":"Se você está prestes a cadastrar o rosto de uma criança, você confirma ser o pai, a mãe ou o responsável legal desta criança.","confirmation-ok-title":"Concordar"}}')
  delete Component.options._Ctor
}
